import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import translate from "react-i18next/dist/commonjs/translate";

class PageErrorMessage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { onReload, t } = this.props;

    return (
      <div className="error-container page-error-message">
        <h2 className="text-center">{t("pageErrorTitle")}</h2>
        <p className="text-center">{t("pageErrorMessage")}</p>
        <button onClick={onReload} className="btn btn-condensed">
          {t("tryAgain")}
        </button>
      </div>
    );
  }
}

PageErrorMessage.propTypes = {
  onReload: PropTypes.func.isRequired
};

export default translate("translations")(connect()(PageErrorMessage));



// WEBPACK FOOTER //
// ./src/common/PageErrorMessage.js